import { ReportItem, ScreenshotData, UploadData } from '@models';

export interface UploadObject {
  id?: string;
  actualSceneIdentifier?: string | undefined;
  sceneIdentifier?: string | undefined;
  sceneNameLanguageKey?: string | undefined;
  sceneSectionLanguageKey?: string | undefined;
  actualSceneNameLanguageKey?: string | undefined;
  startDate?: string;
  endDate?: string;
  state?: number;
  userSession?: string;
  simulatorIdentifier?: string;
  simulatorVersion?: string;
  userInterfaceVersion?: string;
  score?: number;
  maxScore?: number;
  selfAssessmentRating?: number;
  reportSections?: {
    sortId: number;
    isVisible: boolean;
    nameLanguageKey: string;
    sectionIdentifier: string;
    score: number;
    maxScore: number;
    reportItems: ReportItem[];
  }[];
  movies?: UploadData[];
  screenshots?: ScreenshotData[];
  reportAttachments: UploadData[];
  notes?: string;
  courseEntry?: { courseEntryId: string; ensureCertificateIfAchieved: boolean };
}
